import { Controller } from "@hotwired/stimulus";

// MC-817: one-click copy of a short string (a task key) to the
// clipboard. Attach to a focusable control — a <button>, so Enter/Space
// activate it for free — whose `clipboard-text-value` holds the exact
// text to copy (the bare key, e.g. "MC-758"). On activate it writes the
// text via the async Clipboard API and flips `data-copied` on the
// element for brief "Copied" feedback that reverts after a short delay.
//
// The control commonly sits inside a larger clickable surface (the task
// card opens its drawer on click), so `copy` stops the event from
// bubbling — copying the key must not also open the drawer.
export default class extends Controller {
  static values = {
    text: String
  };

  async copy(event) {
    event.stopPropagation();
    event.preventDefault();
    const text = this.textValue;
    if (!text) return;
    try {
      await navigator.clipboard.writeText(text);
      this.showFeedback();
    } catch (_error) {
      // Clipboard writes reject in insecure contexts or when the user
      // denies permission. Nothing to copy and nothing to confirm — fail
      // silently rather than flash a false "Copied".
    }
  }

  showFeedback() {
    this.element.dataset.copied = "true";
    if (this.feedbackTimeout) clearTimeout(this.feedbackTimeout);
    this.feedbackTimeout = setTimeout(() => {
      delete this.element.dataset.copied;
      this.feedbackTimeout = null;
    }, 1200);
  }

  disconnect() {
    if (this.feedbackTimeout) clearTimeout(this.feedbackTimeout);
  }
}
